module.exports = __webpack_public_path__ + "static/media/tntlogo_stretch.993a119b.png";